import React, {Component} from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";
import jsPDF from "jspdf";
import ReactExport from "react-data-export";
import "react-moment";
import moment from "moment";
import {notificarError} from "../componentes/Almacenes/AlmacenNotify";
import { IGV } from "../Global";
import Header from "../componentes/Header";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class ProductosMasVendidos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ProductosMasVendidos: [],
            FechaInicio: moment(new Date()).format('YYYY-MM-DD'),
            FechaFin: moment(new Date()).format('YYYY-MM-DD'),
            idSucursal: 0,
            sucursales: [],
            dataExcelReport: this.getDataProductosExportExcel([]),
            cc: true,
            excelDataReady: false
        };
        this.getProductosMasVendidos = this.getProductosMasVendidos.bind(this);
        this.handleSavePDF = this.handleSavePDF.bind(this);

        this.handleFechaInicio = this.handleFechaInicio.bind(this);
        this.handleFechaFin = this.handleFechaFin.bind(this);
        this.onClickExtraerMasVendidos = this.onClickExtraerMasVendidos.bind(this);
    }

    componentDidMount() {
        this.fetchSucursales();

    }

    fetchSucursales() {
        fetch('/api/sucursales/SucursalEmpresa')
            .then(res => res.json())
            .then(data => this.setState({sucursales: data}))
            .then(() => {
                if (this.state.sucursales.length)
                    this.setState({idSucursal: this.state.sucursales[0].IdSucursal})
            })
    }

    async getProductosMasVendidos(Inicio, Fin) {
        try {
            const response = await fetch(
                `/api/dashboard/get/productos-mas-vendidos-sucursal/${Inicio}/${Fin}/${this.state.idSucursal}?cc=${this.state.cc ? "1" : "0"}`
            );
            const ProductosMasVendidos = await response.json();

            const datosProcesados = ProductosMasVendidos.respuesta.map(item => ({
                ...item,
                TotalVendidoConIgv: (item.Cantidad * item.Venta ).toFixed(2),
            }));

            this.setState({
                ProductosMasVendidos: datosProcesados,
            });
        } catch (error) {
            this.setState({error});
        }
    }

    handleFechaInicio(e) {
        let fechaInicio = e.target.value.length ? e.target.value : moment(new Date()).format('YYYY-MM-DD')
        let fechaFin = this.state.FechaFin.length ? this.state.FechaFin : moment(new Date()).format('YYYY-MM-DD')
        this.setState({
            FechaInicio: fechaInicio,
            FechaFin: fechaFin
        })
    }

    handleFechaFin(e) {
        let fechaInicio = this.state.FechaInicio.length ? this.state.FechaInicio : moment(new Date()).format('YYYY-MM-DD')
        let fechaFin = e.target.value.length ? e.target.value : moment(new Date()).format('YYYY-MM-DD')
        this.setState({
            FechaInicio: fechaInicio,
            FechaFin: fechaFin
        })
    }

    async handleSavePDF() {
        let doc = new jsPDF({
            format: "a4"
        });

        var pageHeight =
            doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        var pageWidth =
            doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
        doc.setFontSize(14);
        doc.text("REPORTE DE PRODUCTOS MÁS VENDIDOS", 55, 10);

        let prods = await this.getProdsForReporte();

        doc.autoTable({
            body: prods,
            theme: "grid",
            columnStyles: {
                text: {
                    columnWidth: "wrap",
                    overflow: "linebreak",
                    halign: "right",
                    valign: "middle"
                },
                codigo: {
                    columnWidth: 25,
                    halign: "right",
                    valign: "middle",
                    overflow: "linebreak"
                },
                nombreProducto: {
                    columnWidth: 30,
                    halign: "left",
                    valign: "middle",
                    overflow: "linebreak"
                },
                fechaVenta: {
                    columnWidth: 30,
                    overflow: "linebreak"
                },
                cantidad: {
                    columnWidth: 20,
                    halign: "right"
                }
            },
            columns: [
                {header: "CÓDIGO", dataKey: "codigo"},
                {header: "NOMBRE PRODUCTO", dataKey: "nombreProducto"},
                {header: "FECHA DE VENTA", dataKey: "fechaVenta"},
                {header: "CANTIDAD", dataKey: "cantidad"},
                {header: "PRECIO VENTA", dataKey: "precioVenta"},
            ]
        });
        doc.setFontSize(10);
        doc.setFontType("italic");
        doc.text("Contatrib ERP", pageWidth - 7, pageHeight - 7, "right");

        doc.save("ProductosMasVendidos.pdf");
    }

    sanitizeValue(value) {
        if (value === null || value === undefined) {
            return "";
        }
        if (typeof value === "number") {
            return value;
        }
        if (typeof value === "string") {
            return value.trim();
        }
        return String(value);
    }

    getDataProductosExportExcel(dataSet) {
        // Validar que dataSet sea un array
        if (!Array.isArray(dataSet)) {
            dataSet = [];
        }

        const columns = [
            { title: "Código", width: { wpx: 90 } },
            { title: "Producto", width: { wpx: 400 } },
            { title: "Fecha de venta", width: { wpx: 100 } },
            { title: "Costo", width: { wpx: 100 } },
            { title: "Cantidad", width: { wpx: 100 } },
            { title: "Precio venta", width: { wpx: 100 } },
            { title: "Descuento", width: { wpx: 100 } },
            { title: "Afectación IGV", width: { wpx: 100 } },
            { title: "Utilidad bruta X UND", width: { wpx: 130 } },
            { title: "Utilidad bruta total", width: { wpx: 130 } },
        ];

        // Sanitizar y validar cada fila de datos
        const data = dataSet.map(row => {
            return [
                { value: this.sanitizeValue(row.codigo) },
                { value: this.sanitizeValue(row.nombreProducto) },
                { value: this.sanitizeValue(row.fechaVenta) },
                { value: this.sanitizeValue(row.costo) },
                { value: this.sanitizeValue(row.cantidad) },
                { value: this.sanitizeValue(row.precioVenta) },
                { value: this.sanitizeValue(row.descuento || "0") },
                { value: this.sanitizeValue(row.descAfectacion) },
                { value: this.sanitizeValue(row.utilidadUnd) },
                { value: this.sanitizeValue(row.utilidadTotal) }
            ];
        });

        return [
            {
                columns: [
                    {
                        title: "Código",
                        width: {wpx: 90}
                    },
                    {
                        title: "Producto",
                        width: {wpx: 400}
                    },
                    {
                        title: "Fecha de venta",
                        width: {wpx: 100}
                    },
                    {
                        title: "P. Venta",
                        width: {wpx: 100}
                    },
                    {
                        title: "Cantidad",
                        width: {wpx: 100}
                    },
                    {
                        title: "Precio venta",
                        width: {wpx: 100}
                    },
                    {
                        title: "Descuento",
                        width: {wpx: 100}
                    },
                    {
                        title: "Afectación IGV",
                        width: {wpx: 100}
                    },
                    {
                        title: "Utilidad bruta X UND",
                        width: {wpx: 130}
                    },
                    {
                        title: "Utilidad bruta total",
                        width: {wpx: 130}
                    },
                ],

                data: dataSet.map(row => {
                    return [
                        {
                            value: row.codigo,
                            style: {
                                fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                            }
                        },
                        {
                            value: row.nombreProducto,
                            style: {
                                fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                            }
                        },
                        {
                            value: row.fechaVenta,
                            style: {
                                fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                            }
                        },
                        {
                            value: row.costo,
                            style: {
                                fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                            }
                        },
                        {
                            value: row.cantidad,
                            style: {
                                fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                            }
                        },
                        {
                            value: row.precioVenta,
                            style: {
                                fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                            }
                        },
                        {
                            value: row.descuento || "0",
                            style: {
                                fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                            }
                        },
                        {
                            value: row.descAfectacion,
                            style: {
                                fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                            }
                        },
                        {
                            value: row.utilidadUnd,
                            style: {
                                fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                            }
                        },
                        {
                            value: row.utilidadTotal,
                            style: {
                                fill: {patternType: "solid", fgColor: {rgb: "F6F8FA"}}
                            }
                        }
                    ];
                })
            }
        ];
    }

    onClickExtraerMasVendidos(e) {
        if (this.state.idSucursal === 0)
            notificarError("Debe seleccionar una sucursal.")
        else {
            this.getProductosMasVendidos(this.state.FechaInicio, this.state.FechaFin)
                .then(() => this.fetchDataForExcel())
        }
    }

    async fetchDataForExcel() {
        try {
            const prods = await this.getProdsForReporte();
            const dataExcelReport = this.getDataProductosExportExcel(prods);
            
            this.setState({ 
                dataExcelReport,
                excelDataReady: true 
            });
        } catch (error) {
            console.error('Error preparing Excel data:', error);
            this.setState({ 
                dataExcelReport: this.getDataProductosExportExcel([]),
                excelDataReady: false 
            });
            notificarError("Error al preparar datos para Excel");
        }
    }


    async getProdsForReporte() {
        let prods = this.state.ProductosMasVendidos;
        let newProds = [];
        for (let i = 0; i < prods.length; i++) {
            let ventas = await this.fetchVentasProducto(prods[i].IdProducto);
            for (let j = 0; j < ventas.length; j++) {
                newProds.push({
                    costo: prods[i].Costo,
                    codigo: prods[i].Codigo,
                    nombreProducto: prods[i].Nombre,
                    descripcion: prods[i].Descripcion,
                    fechaVenta: moment(ventas[j].FechaEmision).format('DD/MM/YYYY HH:mm:ss'),
                    cantidad: ventas[j].Cantidad,
                    precioVenta: ventas[j].precioVenta,
                    descAfectacion: ventas[j].descAfectacion,
                    descuento: ventas[j].descuento,
                    utilidadUnd: (ventas[j].precioVenta - (ventas[j].descuento || 0) - prods[i].Costo),
                    utilidadTotal: (ventas[j].precioVenta - (ventas[j].descuento || 0) - prods[i].Costo) * ventas[j].Cantidad,
                })
            }
        }
        return newProds;
    }

    async fetchVentasProducto(idProd) {
        let res = await fetch(`/api/dashboard/ventas-por-prod/${this.state.FechaInicio}/${this.state.FechaFin}/${idProd}/${this.state.idSucursal}?cc=${this.state.cc ? "1" : "0"}`);
        let data = await res.json();
        return data.ventas;
    }

    render() {
        const {ProductosMasVendidos, dataExcelReport, excelDataReady} = this.state;

        return (
            <>
                {this.state.ProductosMasVendidos ? (
                    <section className="ventas-fpay-section">
                        <div className="container ">
                            <div className="pt-5">
                                
                            </div>
                            <div
                                className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2 mt-3"
                            >
                                <span className="align-self-center letra-fecha-fpay">Desde: </span>
                                <input
                                    type="date"
                                    onChange={this.handleFechaInicio}
                                    defaultValue={this.state.FechaInicio}
                                    className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                                />
                                <span className="align-self-center letra-fecha-fpay">Hasta: </span>
                                <input
                                    type="date"
                                    onChange={this.handleFechaFin}
                                    defaultValue={this.state.FechaFin}
                                    className="input__linea mr-1 pl-2 mt-3 mb-3 linea-fecha-fpay"
                                />
                            </div>
                            <div className="d-flex align-items-center justify-content-between row mb-3">
                                <div className="col-12 col-sm-6">
                                <h3 className="">Productos más vendidos</h3>
                                </div>
                                <div className="d-flex justify-content-end col-sm-auto col-12 col-sm-6">
                                    ¿Solo de ventas?
                                    <input type="checkbox" checked={this.state.cc} onChange={e => {
                                        this.setState({cc: e.target.checked})
                                    }}/>
                                </div>                              
                            </div>
                            <div className="mb-3">
                                <div className="caja-fondo-blanco-m-2 col-sm">
                                    <label className="sucursal-text-color pad-15-fpay" htmlFor="idSucursal">Sucursal</label>
                                    <select name="idSucursal" id="idSucursal" className="form-control"
                                            onChange={e => this.setState({idSucursal: e.target.value})}>
                                        {
                                            [...this.state.sucursales].map(s =>
                                                (<option key={`opt_${s.IdSucursal}`}
                                                         value={s.IdSucursal}>{s.Nombre}</option>)
                                            )
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-3">
                                    <button className="boton__Rojo mr-2" onClick={this.handleSavePDF}>
                                        {<i className="fas fa-file-pdf"/>}
                                    </button>
                            {excelDataReady && ProductosMasVendidos.length > 0 ? (
                                <button style={{ border: 'none', background: 'none'}}>
                                <ExcelFile
                                    element={
                                        <button className="boton__verdeOscuro">
                                            <i className="fas fa-file-excel"/>
                                        </button>
                                    }
                                    filename="ReporteProductosMasVendidos"
                                >
                                    <ExcelSheet
                                        dataSet={dataExcelReport}
                                        name="Productos"
                                    />
                                </ExcelFile>
                                </button>
                            ) : (
                                <button 
                                    className="boton__verdeOscuro"
                                    style={{opacity: 0.5, cursor: 'not-allowed'}} 
                                    disabled
                                    title="Genere el reporte primero"
                                >
                                    <i className="fas fa-file-excel"/>
                                </button>
                            )}

                            </div>
                            <div className="d-flex justify-content-end col-sm-auto mb-3 no-pad">
                                    <button onClick={this.onClickExtraerMasVendidos}
                                            className="btn btn-outline-primary btn-verde-mfp">Generar
                                    </button>
                                </div>        
                            <ReactTable
                                id="table-productos-to-xls"
                                data={this.state.ProductosMasVendidos}
                                filterable
                                defaultFilterMethod={(filter, row) =>
                                    String(row[filter.id]) === filter.value
                                }
                                columns={[
                                    {
                                        columns: [
                                            {
                                                Header: "Código",
                                                id: "Codigo",
                                                accessor: d => d.Codigo,
                                                filterMethod: (filter, rows) =>
                                                    matchSorter(rows, filter.value, {keys: ["Codigo"]}),
                                                filterAll: true
                                            },
                                            {
                                                Header: "Producto",
                                                id: "Nombre",
                                                accessor: d => d.Nombre,
                                                filterMethod: (filter, rows) =>
                                                    matchSorter(rows, filter.value, {
                                                        keys: ["Nombre"]
                                                    }),
                                                filterAll: true
                                            },
                                            {
                                                Header: "Presentación",
                                                id: "NombrePresentacion",
                                                accessor: d => d.NombrePresentacion,
                                                filterMethod: (filter, rows) =>
                                                    matchSorter(rows, filter.value, {
                                                        keys: ["NombrePresentacion"]
                                                    }),
                                                filterAll: true
                                            },
                                            {
                                                Header: "Cantidad",
                                                id: "Cantidad",
                                                accessor: d => d.Cantidad,
                                                filterMethod: (filter, rows) =>
                                                    matchSorter(rows, filter.value, {
                                                        keys: ["Cantidad"]
                                                    }),
                                                filterAll: true,
                                                getProps: (state, rowInfo, column) => {
                                                    return {
                                                        style: {
                                                            textAlign: "right"
                                                        }
                                                    };
                                                }
                                            },
                                            {
                                                Header: "Precio Venta",
                                                id: "Venta",
                                                accessor: d => (d.Venta).toFixed(2),
                                                filterMethod: (filter, rows) =>
                                                    matchSorter(rows, filter.value, {
                                                        keys: ["Venta"]
                                                    }),
                                                filterAll: true,
                                                getProps: (state, rowInfo, column) => {
                                                    return {
                                                        style: {
                                                            textAlign: "right"
                                                        }
                                                    };
                                                }
                                            },
                                            {
                                                Header: "Total Vendido",
                                                id: "TotalVendidoConIgv",
                                                accessor: d => d.TotalVendidoConIgv,
                                                filterMethod: (filter, rows) =>
                                                    matchSorter(rows, filter.value, {
                                                        keys: ["TotalVendidoConIgv"]
                                                    }),
                                                filterAll: true,
                                                getProps: (state, rowInfo, column) => {
                                                    return {
                                                        style: {
                                                            textAlign: "right"
                                                        }
                                                    };
                                                }
                                            }
                                        ]
                                    }
                                ]}
                                defaultPageSize={10}
                                className="-striped -highlight"
                                previousText="Anterior"
                                nextText="Siguiente"
                                noDataText="No se encontraron registros"
                                loadingText="Cargando..."
                                ofText="de"
                                rowsText="filas"
                                pageText="Página"
                                pageSizeOptions={[10, 20, 25, 50, 100]}
                            />
                        </div>
                    </section>
                ) : (
                    <div>Cargando Productos</div>
                )}
            </>
        );
    }
}

export default ProductosMasVendidos;
